var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ChatCollapseIcon = function (_a) {
    var style = _a.style, props = __rest(_a, ["style"]);
    return (_jsxs("svg", __assign({ width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', style: style }, props, { children: [_jsx("path", { opacity: '0.32', d: 'M14.3283 11.4343L18.5126 7.24998C18.9268 6.83578 18.9268 6.16418 18.5126 5.74998C18.0984 5.33578 17.4268 5.33578 17.0126 5.74998L11.4696 11.2929C11.0792 11.6834 11.0792 12.3166 11.4696 12.7071L17.0126 18.25C17.4268 18.6642 18.0984 18.6642 18.5126 18.25C18.9268 17.8358 18.9268 17.1642 18.5126 16.75L14.3283 12.5657C14.254 12.4914 14.195 12.4032 14.1548 12.3061C14.1146 12.2091 14.0939 12.105 14.0939 12C14.0939 11.8949 14.1146 11.7909 14.1548 11.6938C14.195 11.5968 14.254 11.5086 14.3283 11.4343Z', fill: '#637381' }), _jsx("path", { d: 'M8.32826 11.4343L12.5126 7.24998C12.9268 6.83578 12.9268 6.16418 12.5126 5.74998C12.0984 5.33578 11.4268 5.33578 11.0126 5.74998L5.46956 11.2929C5.07916 11.6834 5.07916 12.3166 5.46956 12.7071L11.0126 18.25C11.4268 18.6642 12.0984 18.6642 12.5126 18.25C12.9268 17.8358 12.9268 17.1642 12.5126 16.75L8.32826 12.5657C8.25397 12.4914 8.19503 12.4032 8.15483 12.3061C8.11462 12.2091 8.09393 12.105 8.09393 12C8.09393 11.8949 8.11462 11.7909 8.15483 11.6938C8.19503 11.5968 8.25397 11.5086 8.32826 11.4343Z', fill: '#637381' })] })));
};
export default ChatCollapseIcon;
